import { Badge, Quiet } from "../../ui/Badge";
import { STATUS_LABEL, type RequestStatus } from "../../data/requestQueries";

/**
 * What the client's Ärenden pages share: how a status is said and how a moment is written.
 *
 * design.md section 3, rule 2 (2026-09-24): what is normal is a grey word. Of the five statuses only
 * "Väntar på er" asks something of the client, so it is the only one drawn as a badge, in the warn
 * tone, exactly as `prototype/kund/pages.js` `statusBadge()` draws it. The word carries the meaning
 * in both shapes, so the tone is never the only signal.
 */
export function StatusWord({ status, testId }: { status: RequestStatus; testId?: string }) {
  const label = STATUS_LABEL[status] ?? status;

  return status === "waiting_for_client" ? (
    <Badge tone="warn" testId={testId}>
      {label}
    </Badge>
  ) : (
    <Quiet testId={testId}>{label}</Quiet>
  );
}

/**
 * Build round A2, 2026-10-08: "Över månadens tak", on a request created when the month's small
 * changes were already used and still waiting for Petrovic's choice. In the info tone, the same as
 * the box on the request's page: it is not normal, so it is not a grey word, and it asks nothing of
 * the client, so it is not the warn tone that "Väntar på er" alone has.
 */
export function OverCapTag({ testId = "request-over-cap" }: { testId?: string }) {
  return (
    <span className="k-req-flag">
      <Badge tone="info" testId={testId}>
        Över månadens tak
      </Badge>
    </span>
  );
}

